function ArrowRight(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
      <path fill="currentColor" d="M5.975 17.504l14.287.001-6.367 6.366L16.021 26l10.004-10.003L16.029 6l-2.128 2.129 6.367 6.366H5.977z"/>
    </svg>
  );
}

export default ArrowRight;
